export default "__VITE_ASSET__B0ZROW9P__"